import axios from "axios"
import { getToken, Permission } from "./authApi"
import { ApiResponse, BaseCreateResponse, BaseInfo, BaseResponse, BaseResponseWithData, baseUrl, deleteWithAuth, getWithAuth, Guid, ListRespone, patchWithAuth, postWithAuth, postWithAuthWitoutParams } from "./baseApi"


export enum AlertType {
    //1. System Related (Send email instantly)
    NewPlayerRegistered = 1,
    PlayerOfflineContinuouslyRorMoreThan5mins = 2,
    PlayerOnline = 3,
    PlayerUpdatedToNewVersion = 4,
    PlayerCrash = 5,
    PlayerFreezeForMoreThan30Seconds = 6,
    PlayerRestartedByCplayerGuardian = 7,
    PlayerCPUUtilizationAbove75PercentContinuouslyAfter3Mins = 8,
    PlayerGPUUtilizationAbove60PercentContinuouslyAfter3Mins = 9,
    PlayerDiskUtilizationAbove75PercentContinuouslyAfter3Mins = 10,
    PlayerNotResponding = 11,
    PlayerRestartedByRequest = 12,
    PlayerRestartedByFreeze = 13,
    Dolby = 14,
    RainbowScreen = 15,
    ExternalUserUploadedMedia = 16,
    ExternalUserApprovedOrRejectedMedia = 17,

    //2. User related(Send email instantly)
    NewUserAdded = 101,
    UserDisabled = 102,
    UserEnabled = 103,
    
    //3. Campaign related(Group every below email by 5 mins?)
    NewCampaignCreated = 201,
    CampaignStartedByTheStartDate = 202,
    CampaignPlayedByThePlayButton = 203,
    CampaignFinishedByTheEndDate = 204,
    CampaignStoppedByTheStopButton = 205,
    CampaignAchievedByTheArchiveButton = 206,
    CampaignStillInDraftMode24hoursAdvancedAlertPriorToStartDate = 207,
    CampaignHasNoMediaAssets48HoursAdvancedAlertPriorToStartDate = 208,
    ExternalUserCreatedCampaign = 209,

    //4.  Site related(Group every below email by 5 mins?)
    NewSiteCreated = 301,
    NewPlayerAddedToTheSite = 302,
    NewPlayerRemovedFromTheSite = 303,
    NewPlaylistAddedUnderASite = 304,
    PlaylistDeletedUnderASite = 305,
    ExternalUserAssignedMediaToGroup = 306,

}

export type User = {
    id: string,
    name : string,
    email: string,
    permissions: Permission[]
    isSuspended: boolean,
    externalOrganisationId?: Guid,
    externalOrganisationName?: string
}

export type CreateUserRequest = {
    name : string,
    email: string,
    password: string,
    externalOrganisationId?: Guid,
    permissions: Permission[]
}

export type UpdateUserRequest = {
    name : string,
    email: string,
    permissions: Permission[]
}

export type UpdateUserNotificationsRequest = {
    notificationTypes: AlertType[]
}

export type ChangePasswordRequest = { 
    password: string
}

export type ChangeUsernameRequest = { 
    username: string
}

export const getUsersList = async() : Promise<ApiResponse<ListRespone<User>>> => {
    return await getWithAuth<ListRespone<User>>({url : `${baseUrl}users`});
}

export const getUser = async(id: Guid) : Promise<ApiResponse<User>> => {
    return await getWithAuth<User>({url : `${baseUrl}users/${id}`});
}

export const getUserNotifications = async(id: Guid) : Promise<ApiResponse<ListRespone<AlertType>>> => {
    return await getWithAuth<ListRespone<AlertType>>({url : `${baseUrl}users/${id}/notifications`});
}

export const createUser = async ( request:CreateUserRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<CreateUserRequest,BaseCreateResponse>(`${baseUrl}users`, request);
}

export const updateUser = async (id: Guid, request:UpdateUserRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await patchWithAuth<UpdateUserRequest,BaseCreateResponse>(`${baseUrl}users/${id}`, request);
}

export const updateUserNotifications = async (id: Guid, request:UpdateUserNotificationsRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await patchWithAuth<UpdateUserNotificationsRequest,BaseCreateResponse>(`${baseUrl}users/${id}/notifications`, request);
}

export const deleteUser = async (id: Guid) : Promise<ApiResponse<BaseResponse>> => {
    return await deleteWithAuth<BaseResponse>(`${baseUrl}users`, id)
}

export const suspendUser = async (id: Guid) : Promise<ApiResponse<BaseResponse>> => {
    return await postWithAuthWitoutParams<BaseResponse>(`${baseUrl}users/${id}/suspend`);
}

export const unSuspendUser = async (id: Guid) : Promise<ApiResponse<BaseResponse>> => {
    return await postWithAuthWitoutParams<BaseResponse>(`${baseUrl}users/${id}/unsuspend`);
}


export const changeUserPassword = async (request: ChangePasswordRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<ChangePasswordRequest, BaseResponse>(`${baseUrl}users/password`, request);
}

export const changeUsername = async (request: ChangeUsernameRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<ChangeUsernameRequest, BaseResponse>(`${baseUrl}users/username`, request);
}


export const updateProfilePicture = async (formData: any) : Promise<string> => {
     await axios.post(`${baseUrl}users/profilePicture`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization' : getToken()
        }, 
    });

    return "ok";
}

export const getProfilePicture = async () : Promise<ApiResponse<BaseResponseWithData<string>>> => {
    return await getWithAuth<BaseResponseWithData<string>>({url : `${baseUrl}users/profilePicture`});
}


